import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusinessManageOrderContainer} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';

class MyBusinessManageOrderPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyBusinessManageOrderPage;
  }

  render() {
    return (
      <MasterLayout>
        <MyBusinessManageOrderContainer params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessManageOrderPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessManageOrderPage.jsx